export const iconFontAwesomeArrowsRepeat = (
	<i className="fa-solid fa-repeat"></i>
);
